const TEXT_BLOCK_NAME_PREFIX = '_textBlock_';

export const addTextBlockPrefix = (textBlockId: number) =>
    TEXT_BLOCK_NAME_PREFIX + textBlockId;

export const removeTextBlockPrefix = (prefixedTextBlockName: string) =>
    parseInt(prefixedTextBlockName.replace(TEXT_BLOCK_NAME_PREFIX, ''), 10);

export const hasTextBlockPrefix = (name: string) =>
    name.startsWith(TEXT_BLOCK_NAME_PREFIX);
